import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuFR from "../../components/fr/MenuFR";
import FooterFR from "../../components/fr/FooterFR";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Frank Coel – Avocat à Malines"}
                    description={"Avocat en droit administratif, droit de la fonction publique, droit civil et droit pénal. Fusions, acquisitions et liquidations et litiges entre associés. "}
                    url={"https://www.coeladvocaten.be/fr/frank-coel"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/frank-coel", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/frank-coel", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/frank-coel", language:"en" }
                    ]}
                />

                <MenuFR
                    switchUrlNL="/nl/frank-coel"
                    switchUrlEN="/en/frank-coel"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-team"></div>
                        <div className="slider">
                            <h1>Notre équipe</h1>
                            <h2>Frank Coel</h2>
                            <p></p>
                            <a href="/fr/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <div className="image">
                                                <img className="img-fluid grayscale team-image-opacity" src="/static/images/ons-team-frank.jpg" width="100%" height="auto" /> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Spécialiste de la défense des droits des particuliers et des entreprises, en particulier face aux autorités, Frank Coel pratique le droit administratif, le droit de la fonction publique, le droit civil et le droit pénal. C’est aussi un expert reconnu des fusions, acquisitions et liquidations et de la résolution de litiges entre associés.</p>
                                            <p></p>
                                            <p><b>Spécialités</b></p>
                                            <p>-	<b>Droit administratif</b> : défense des particuliers et des entreprises face aux décisions des autorités, à quelque niveau que ce soit, de la simple procédure de révision au recours devant le Conseil d’État</p>
                                            <p>-	<b>Droit de la fonction publique</b> : procédures de nomination, révocation et licenciement des agents statutaires et des agents contractuels</p>
                                            <p>-	<b>Droit pénal</b> : défense des inculpés et des victimes depuis le tribunal de police et le tribunal de 1e instance jusqu’à la Cour de cassation</p>
                                            <p>-	<b>Droit des affaires</b> : fusions, acquisitions, réorganisations, liquidations, litiges entre associés</p>
                                            <p>-	<b>Droit civil</b> : baux à ferme, baux fonciers, servitudes, loyers, baux commerciaux et recours contre les expropriations</p>
                                            <p></p>
                                            <p><b>Etudes et formations</b></p>
                                            <p>Licence en Droit – Vrije Universiteit Brussel – 1990</p>
                                            <p>Stage d’avocat chez stage chez Feremans, Vets & Verreydt à Malines</p>
                                            <p>Attestation de formation à la Cassation pénale – 2016</p>
                                            <p></p>
                                            <p><b>Activités</b></p>
                                            <p>-	Membre du Barreau de Malines, puis de la Province d’Anvers, depuis 1990</p>
                                            <p>-	Membre du Conseil et trésorier de l’Ordre de Malines jusque 2019</p>
                                            <p>-	Membre de diverses commissions de l'Ordre des Barreaux flamands.</p>
                                            <p>-	Membre de la Commission de Discipline en Appel depuis 2019</p>
                                            <p>-	Conseiller provincial de la Province d’Anvers de 2000 à 2006</p>

                                            {/* <p></p>
                                            <p>Contact</p>
                                            <p><i className="fa fa-envelope"></i>&nbsp;frank@coeladvocaten.be</p>
                                            <p><i className="fa fa-phone"></i>&nbsp;+32 15 41 76 36</p>
                                            <p>&nbsp;</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterFR />
            </Layout>
        );
    }
}

export default Index;
